import React from "react";
import "./styles.css";
import bg from './ImagenesBannerERP/banner.jpg';

export default function BannerERP(props) {
    

    return (
        <>
            <div className="contenedorGeneralBannerERP">
                <div className="contenedorPrincipalBannerERP">
                <img src={bg}/>
                    <div className="contenedorTextoBannerERP">
                    <h3>T&T ERP</h3>
                        <h4>
                            facilita la operación <br/>
                            de tu negocio
                        </h4>
                    </div>
                </div>
            </div>
        </>
    );
}
